import React, {useState, useContext} from "react"
import {JourneyContext} from "../context/journeyContext"
import { uploadDocument, aesEncryptData } from "../../services/apiservice"
import { withPrefix } from "gatsby"
import pdfIcon from "../../../static/images/ekyc2.png"
import { getValueFromJourney } from "../services/helperFunctions"
import { lineCapital } from "../../shared/functions"
import { errorToastr } from "../../services/error-handler"
import { accessToken } from "../../interceptors/jwt-interceptor"
import base64 from 'base-64'


let uploadFormControlKey2 = ["payorPANFileUpload", "payorIDFileUpload"]

export default function ComponentUpload(props) {

  const [responseDocument, setResponseDocument] = useState({
    "LA_ANC_": {
      location: "",
      fileName: "",
      msg: "",
    },
    "LA_DLP_": {
      location: "",
      fileName: "",
      msg: "",
    },
    "SPOUSE_ANC_": {
      location: "",
      fileName: "",
      msg: "",
    },
    "SPOUSE_DLP_": {
      location: "",
      fileName: "",
      msg: "",
    }
  })
  // const [isUploading, setIsUploading] = useState(false)
  const [journeyState,setJourneyState] = useContext(JourneyContext)

  const isPdf = val => {
    if(!val){
      return true
    }
    let format = val?.split(".")?.[val.split(".").length - 1]
    if(!format){
      return true
    }
    return  ["tiff", "pdf","tif"].includes(format.toLowerCase())
  }

  const uploadFile = async (e, field) => {
    // if (isUploading) {
    //   return
    // }
    let file = e?.target?.files[0]
    console.log(file, "file")
    if(!file){
      return 
    }
   
    //check for file size
    if(file.size > 5242880){
      errorToastr("Maximum file sixe allowed is 5 Mb")
      return
    }

    //check for double extension
    let hasDoubleFormat = file.name?.split(".")?.length > 2
    if(hasDoubleFormat){
      errorToastr("This file is not supported")
      return
    }

    //Check for file format
    let fileFormat = file.name?.split(".")?.[1]
    console.log(fileFormat, "fileFormat")
    if(!fileFormat || !(["png","jpg", "jpeg", "tiff","tif", "pdf"]).includes(fileFormat.toLowerCase())){
      errorToastr("This file is not supported")
      return
    }
    
    //Check for null type
    if (file.size < 10) {
      errorToastr("Invalid file")
      return
    }

    //Check for mimetype
    if (!["image/x-png", "image/png", "application/pdf", "image/jpeg", "image/tiff"].includes(file.type)) {
      errorToastr("File not supported")
      return
    }
    
    let formData = new FormData()
    if (e?.target?.files.length) {
        // setIsUploading(true)
      const file = e.target.files[0]
      formData.append("doc", file)
      formData.append("sub", false)
      let name = e.target.files?.[0]?.name || ""
      formData.append(
        "docPurpose", Date.now() + "-" +
        field + "." +
      name.split(".")[1]
      )
      formData.append(
        "uploadDocPurpose", field.split("_")[1]
      )
      console.log(formData)
      try {
        const res = await uploadDocument(formData, journeyState.applicationNo)
        console.log(res, "abcd", field)
        if(res?.location == ''){
          errorToastr("File not supported")
        }
        let location = res.location
        let encryptedToken = aesEncryptData({accessToken: accessToken})
        let base64EncodedToken = base64.encode(encryptedToken)
        // console.log("base64EncodedToken", base64EncodedToken)
        let newLocation = `${location}?auth=${base64EncodedToken}`
        // console.log("newLocation", newLocation)
        res.location = newLocation

        setResponseDocument({
          ...responseDocument,
          [field]: res,
        })
        // setIsUploading(false)
      } catch (error) {
        // setIsUploading(false)
      }
    }
  }

  const handleEnter = (e,field) =>{
    if(e.key == 'Enter'){
      let el = document.getElementById(field)
      el.click()
    }
  }

  console.log(props)
  return (
    <div className="input-container">
      {uploadFormControlKey2.includes(props.data.formControlKey) ? (
        <div
          style={{
            border: "1px solid #d7d7d7",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            padding: "1rem",
          }}
        >
          <label
            className="choose-file-design"
            style={{ marginRight: "1rem", padding: "7px 20px" }}
            tabIndex="0"
            onKeyPress={(e)=>{handleEnter(e,'upld1')}}
          >
            <input id="upld1" type={props.data.type} style={{ display: "none" }} onInput={e => uploadFile(e, props.data?.docPurpose)}
              accept="image/x-png,application/pdf,image/jpeg, image/tiff"
            />
            <div className="filesrow">
              <div className="upload">{(getValueFromJourney(
          journeyState.lookup.label,
          props.data.label
        )) || props.data.label}</div>
            </div>
          </label>
          <div className="uprow">
            <img src={withPrefix("/images/upload2.png")} style={{ height: "5rem" }} />
          </div>
        </div>
      ) : (
        <>
          <div className="uprow">
            <img style={{height: "5rem", width: "5rem"}} src={
              (responseDocument[props.data.docPurpose] && responseDocument[props.data.docPurpose].fileName)
                ? isPdf(responseDocument[props.data.docPurpose].fileName)
                  ? pdfIcon
                  : responseDocument[props.data.docPurpose].location
                : withPrefix("/images/upicon1.png")
            } />
            {(responseDocument[props.data.docPurpose] && responseDocument[props.data.docPurpose].fileName) ? "" : (getValueFromJourney(
          journeyState.lookup.label,
          props.data.label
        )) || props.data.label}
          </div>
          <label
            className="choose-file-design"
            style={{ margin: "0 5rem !important" }}
            tabIndex="0"
            onKeyPress={(e)=>{handleEnter(e,'upld2')}}
          >
            <input id="upld2" type={props.data.type} style={{ display: "none" }} onInput={e => uploadFile(e, props.data?.docPurpose)}
              accept="image/x-png,application/pdf,image/jpeg, image/tiff"
            />
            <div className="filesrow">
              <div className="upload">UPLOAD</div>
            </div>
          </label>
        </>
      )}
    </div>
  )
}
